export default __webpack_public_path__ + "static/media/DriningTime.88ec1229.jpg";